<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.3563 16.7406C23.3438 14.6094 24.3094 13.0031 26.2594 11.8188C25.1687 10.2563 23.5187 9.39688 21.3438 9.23125C19.2844 9.06875 17.0312 10.4313 16.2062 10.4313C15.3344 10.4313 13.3406 9.2875 11.7719 9.2875C8.53438 9.3375 5.09375 11.8688 5.09375 17.0188C5.09375 18.5406 5.37187 20.1125 5.92812 21.7313C6.67187 23.8625 9.35312 29.0844 12.15 29C13.6125 28.9656 14.6469 27.9625 16.55 27.9625C18.3969 27.9625 19.3531 29 20.9844 29C23.8062 28.9594 26.2313 24.2125 26.9375 22.075C23.1531 20.2906 23.3563 16.85 23.3563 16.7406ZM20.0719 7.20938C21.6562 5.32813 21.5125 3.61563 21.4656 3C20.0656 3.08125 18.4469 3.95313 17.525 5.025C16.5094 6.175 15.9125 7.59688 16.0406 9.2C17.5531 9.31563 18.9344 8.5375 20.0719 7.20938Z" fill="black"/>
  </svg>
</template>

<script>
export default {
  props: {
    size: { type: String }
  }
}
</script>